import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Record, slot } from 'src/app/features/Events-and-guests/models/List.Event';
import { RestaurantDetails } from 'src/app/features/restaurants/models/List.Restaurant';
import { RestaurantService } from 'src/app/features/restaurants/services/Restaurant.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import Swal from 'sweetalert2';
import { EventService } from '../../services/Events.service';
export interface DialogData {
  record: Record
}
@Component({
  selector: 'app-event-form',
  templateUrl: './event-form.component.html'
})
export class EventFormComponent extends DirtyComponent implements OnInit {
  override formGroup!: FormGroup;
  loading = false;
  restaurantloading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data.record ? true : false;
  allRestaurants: RestaurantDetails[] = [];
  details!: Record;

  disableButton = false;

  // image file
  logo: any;
  logoSrc!: string;
  maxFileSize = 0.5;
  fileExt!: string;
  fileTypeError = false;
  fileSizeError = false;
  @ViewChild('InputFile') InputFile!: ElementRef;


  restaurantId = localStorage.getItem('restaurantId')

  hours: slot[] = [];
  hoursLoading = false;

  slots = new FormControl([], Validators.required);
  isSelected = false;
  isHoursSelected = false;
  constructor(override dialogRef: MatDialogRef<EventFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder,
    translate: TranslateService,
    private service: EventService,
    private restaurantService: RestaurantService,
    private cdr: ChangeDetectorRef
    ) {
    super(translate)
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }


  ngOnInit(): void {
    this.buildForm();
    this.GetRestaurants()
    if (this.isUpdate) {
      this.GetDetails();
    }

  }

  GetRestaurants() {
    this.restaurantloading = true;
    this.restaurantService.GetOwneRestaurant().subscribe((data: any) => {
      this.restaurantloading = false;
      this.allRestaurants = data.pageData;
    })
  }
  GetDetails() {
    this.loading = true;
    this.service.GetDetails(this.data.record.id).subscribe((data: any) => {
      this.details = data;
      this.loading = false;
      this.bindDataToUpdate();
    })
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      restaurantID: [this.restaurantId],
      // icon: [null, Validators.required],
      title_EN: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(20),
        // Validators.pattern(Patterns.enTxt),
        Validators.required
      ]],
      title_AR: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(20),
        // Validators.pattern(Patterns.arTxt),
        Validators.required
      ]],
      isSeveralDays: [false],
      startDate: [null, Validators.required],
      endDate: [null],
      startTime: [null, Validators.required],
      endTime: [null, Validators.required],
      note: [null],
      branches: new FormControl([], Validators.required)
    });
  }

  bindDataToUpdate() {
    this.formGroup.patchValue(this.details);
    this.logoSrc = this.details.icon;
    this.formGroup.controls['startDate'].setValue(this.details.startDate.gregorian);
    this.formGroup.controls['endDate'].setValue(this.details?.endDate?.gregorian);
    this.hours = this.details.slots;
    if (this.hours.filter((item: any) => item.isActive).length == this.details.slots?.length) {
      this.isHoursSelected = true
    }
    if (this.formGroup.controls['branches'].value?.length == this.allRestaurants?.length) {
      this.isSelected = true;
    }
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
  override canDeactivate(): boolean {
    return this.formGroup.dirty;
  };

  selectAllBranches() {
    if (this.formGroup.controls['branches'].value?.length == this.allRestaurants?.length) {
      this.formGroup.controls['branches'].reset()
      this.isSelected = false;
    }
    else {
      this.formGroup.controls['branches'].setValue(
        this.allRestaurants.map(x => x.id)
      )
      this.isSelected = true;
    }
  }

  selectAllSlots() {
    if (this.isHoursSelected) {
      this.hours.map(item => {
        item.isActive = false
      })
      this.isHoursSelected = false;
    }
    else {
      this.hours.map(item => {
        item.isActive = true
      })
      this.isHoursSelected = true;
    }
  }
  validateDateTime() {
    if (this.formGroup.controls['startTime'].value && this.formGroup.controls['endTime'].value) {
      // ResId: number, start: string, end: string
      this.hoursLoading = true;
      this.service.getEventSlots(this.formGroup.controls['startTime'].value, this.formGroup.controls['endTime'].value).subscribe((res: any) => {
        this.hours = res;
        this.hoursLoading = false;
      })
    }
  }

  scrollToError() {
    setTimeout(() => {
      if (document.getElementsByClassName('mat-form-field-invalid').length) {
        this.scrollTo('mat-form-field-invalid');
      }
      if (document.getElementsByClassName('has-error').length) {
        this.scrollTo('has-error');
      }
      if (document.getElementsByClassName('is-invalid').length) {
        this.scrollTo('is-invalid');
      }
    }, 100);
  }
  scrollTo(className: string) {
    document.getElementsByClassName(className)[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }

  onSeveralDaysChanges($event: any) {
    this.formGroup.controls['endDate'].reset()
  }
  saveRecord() {
    this.isSubmitted = true;
    this.scrollToError();

    if (this.formGroup.valid && this.logoSrc && this.formGroup.controls['startTime'].value !== this.formGroup.controls['endTime'].value) {
      this.loading = true;
      let data: any
      this.hours.map(item => {
        item.isActive = this.slots.value?.some((x: any) => x.id == item.id) || false
      })
      data = {
        restaurantID: this.restaurantId,
        title_EN: this.formGroup.controls['title_EN'].value,
        title_AR: this.formGroup.controls['title_AR'].value,
        isSeveralDays: this.formGroup.controls['isSeveralDays'].value ? true : false,
        startDate: this.formGroup.controls['startDate'].value,
        endDate: (this.formGroup.controls['isSeveralDays'].value == true) ? this.formGroup.controls['endDate'].value : '',
        startTime: this.formGroup.controls['startTime'].value,
        endTime: this.formGroup.controls['endTime'].value,
        note: this.formGroup.controls['note'].value,
        branches: this.formGroup.controls['branches'].value,
        slots: this.hours
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.id = this.data.record.id
        data.startDate = this.formGroup.controls['startDate'].value
        data.endDate = (this.formGroup.controls['isSeveralDays'].value == true) ? this.formGroup.controls['endDate'].value : ''
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.saveRecord(data, this.logo).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }



  // File preview with validation
  changeFileListener($event: any): void {
    const file: File = $event.target.files[0];
    if (file) {
      if (this.validateFile(file)) {
        this.readThis(file);
        this.logo = file;
      } else {
        this.logoSrc = '';
        this.logo = undefined;
      }
    } else {
      this.logoSrc = '';
      this.logo = undefined;
    }
  }
  readThis(file: File): void {
    const myReader: FileReader = new FileReader();
    if (this.fileType(file.name) === 'svg') {
      myReader.readAsText(file);
    } else {
      myReader.readAsDataURL(file);
    }
    myReader.onloadend = (e) => {
      this.logoSrc = myReader.result as string;
    };
  }
  validateFile(file: File): any {
    this.fileExt = this.fileType(file.name);
    if (this.fileExt) {
      this.fileTypeError = false;
      if ((file.size / (1024 * 1024)) <= this.maxFileSize) {
        this.fileSizeError = false;
      } else {
        this.fileSizeError = true;
        return false;
      }
    } else {
      this.fileTypeError = true;
      return false;
    }
    return true;
  }
  fileType(fileName: string): any {
    const extension = fileName.split('.')?.pop()?.toLowerCase();
    switch (extension) {
      case 'svg':
        return 'svg';
      case 'jpg':
      case 'jpeg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }
}
